module.exports = __webpack_public_path__ + "img/1080a19.jpg";